import { Card, CardBody } from "@heroui/react"
import { Link, useMatchRoute } from '@tanstack/react-router'
import classNames from 'classnames'
import NavigationLink from '../model/navigation-link'
import styles from './navbar.module.scss'

interface NavbarProps {
  className?: string
  links: NavigationLink[]
}

export default function Navbar({ className, links }: NavbarProps) {
  const matchRoute = useMatchRoute()

  const checkIsLinkActive = (link: NavigationLink) => {
    if (matchRoute({ to: link.to, fuzzy: true })) return true
    if (link.matches?.some(to => matchRoute({ to, fuzzy: true }))) return true
    return false
  }

  return (
    <Card className={classNames(className, styles.root)}>
      <CardBody>
        <div className={styles.body}>
          {links.map(link => (
            <Link
              className={classNames(styles.link, checkIsLinkActive(link) && styles.linkActive)}
              to={link.to}
              key={link.to}
              title={link.displayName}
            >
              {link.icon}

              <span className={styles.linkName}>{link.displayName}</span>
            </Link>
          ))}
        </div>
      </CardBody>
    </Card>
  )
}
